module.exports = __webpack_public_path__ + "img/header-poster.2c638e52.png";